import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import { assignTasktoUser, ClaimStatusChange, getMyWorkList } from "./asyncThunkApi";


const myworkSlice = createSlice({
    name: "mywork",
    initialState: initialState,
    reducers: {
        resetToInitial: () => initialState,
        setNotification: (state, action) => {
            const { message, type, title } = action.payload;
            state.notify_message = {
                show: true,
                message: message || "",
                type: type || "info",
                title: title || ""
            };
        },
        // Use this to reset the state completely
        clearNotification: (state) => {
            state.notify_message = {
                ...initialState.notify_message,
                show: false
            };
        },
        setMyWorkListSort: (state, action) => {
            const sortField = action.payload;

            // Set sort field and toggle order type
            state.workListTable.sortField = sortField;
            state.workListTable.orderType = state.workListTable.orderType === "" ? "-" : "";

            // Reset all ordering flags to true (default state)
            const resetOrderingFlags = () => {
                state.workListTable.initialOrderingPatientName = true;
                state.workListTable.initialOrderingClaimId = true;
                state.workListTable.initialOrderingDos = true;
                state.workListTable.initialOrderingBillDate = true;
                state.workListTable.initialOrderingCharges = true; // New
                state.workListTable.initialOrderingBalance = true; // New
            };

            // Helper to flip the specific flag
            const setOrderingFlag = (flagName) => {
                resetOrderingFlags();
                state.workListTable[flagName] = false;
            };
            switch (sortField) {
                case "patient__full_name":
                    setOrderingFlag('initialOrderingPatientName');
                    break;
                case "custom_claim_id":
                    setOrderingFlag('initialOrderingClaimId');
                    break;
                case "service_from_date":
                    setOrderingFlag('initialOrderingDos');
                    break;
                case "last_billed_date":
                    setOrderingFlag('initialOrderingBillDate');
                    break;
                case "total_charges":
                    setOrderingFlag('initialOrderingCharges');
                    break;
                case "balance_amount":
                    setOrderingFlag('initialOrderingBalance');
                    break;
                default:
                    resetOrderingFlags();
                    break;
            }
        },
        setClaimIdOpenInNewTab: (state) => {
            state.claim_id_open_in_new_tab = "";
            state.makeInProgressStatus = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getMyWorkList.pending, (state) => {
                state.loading = true
            })
            .addCase(getMyWorkList.fulfilled, (state, action) => {
                state.loading = false
                state.myworkList = action.payload?.results
                state.count = action.payload?.count
            })
            .addCase(getMyWorkList.rejected, (state) => {
                state.loading = false
            })
            .addCase(assignTasktoUser.pending, (state) => {
                state.loading = true
            })
            .addCase(assignTasktoUser.fulfilled, (state, action) => {
                const { assigned_count, data } = action.payload;
                state.loading = false
                if (assigned_count > 0 && Array.isArray(data) && data.length > 0) {
                    data.forEach(item => {
                        if (Array.isArray(item)) {
                            state.myworkList = [...state.myworkList, ...item]
                        } else if (item) {
                            state.myworkList = [...state.myworkList, item]
                        }
                    });
                }
                state.isDataInitialized = true
            })
            .addCase(assignTasktoUser.rejected, (state, action) => {
                state.loading = false
                const { message } = action.payload;
                state.notify_message = {
                    show: true,
                    message: message || "",
                    type: "error",
                };

            }),
            builder.addCase(ClaimStatusChange.pending, (state) => {
                state.loading = true
            })
            .addCase(ClaimStatusChange.fulfilled, (state,action) => {
                state.loading = false
                state.makeInProgressStatus = true;
                state.claim_id_open_in_new_tab = action.payload.id;
            })
            .addCase(ClaimStatusChange.rejected, (state, action) => {
                state.loading = false
                const { message } = action.payload;
                state.makeInProgressStatus = false;
                state.notify_message = {
                    show: true,
                    message: message || "",
                    type: "error",
                };
            })
    }
})

export const { setNotification, clearNotification, setMyWorkListSort,setClaimIdOpenInNewTab,resetToInitial } = myworkSlice.actions;
export default myworkSlice.reducer;